import { Form, Formik, useFormik } from "formik";
import { Dispatch, LegacyRef, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { genderEnum } from "src/core/enums/gender-enum";
import * as list from "src/core/statics/form-data/form-data";
import { AddSonValuesType } from "src/core/types/add-son-form-type";
import SelectProfileForms from "./select-forms-profile-component";
import { addSonValidationSchema } from "./validation/add-son-validation";

interface IProps {
  addSonFormRef: LegacyRef<HTMLDivElement>;
  addSonToList: (sonData: AddSonValuesType) => void;
  setShowAddSonForm: Dispatch<SetStateAction<boolean>>;
}

function AddSonFormComponent(props: IProps) {
  const [openForm, setOpenForm] = useState(1);
  const [gender, setGender] = useState("");
  const [validGender, setValidGender] = useState<boolean>(false);
  const [validEduLevel, setValidEduLevel] = useState<boolean>(false);
  const [validEduSystem, setValidEduSystem] = useState<boolean>(false);
  const [showEduSystemOptions, setShowEduSystemOptions] =
    useState<boolean>(false);
  const [showEduLevelOptions, setShowEduLevelOptions] =
    useState<boolean>(false);
  const [isEduSystemSelected, setIsEduSystemSelected] =
    useState<boolean>(false);
  const [isEduLevelSelected, setIsEduLevelSelected] = useState<boolean>(false);
  const [eduSystem, setEduSystem] = useState("");
  const [eduLevel, setEduLevel] = useState("");
  const [type, setType] = useState("text");
  const initialValues: AddSonValuesType = {
    nameOfSon: "",
    birthDate: "",
    gender: "",
    eduLevel: "",
    eduSystem: "",
    idNumber: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: addSonValidationSchema,
    onSubmit: async () => {
      props.addSonToList(formik.values);
      props.setShowAddSonForm(false);
    },
  });
  const handleNextForms = async (step: number) => {
    formik.setTouched({}, false);
    switch (step) {
      case 1:
        const errors = await formik.validateForm();
        if (!errors.nameOfSon && !errors.birthDate) {
          setOpenForm(openForm + 1);
        } else {
          if (errors.nameOfSon) {
            formik.setFieldTouched("nameOfSon", true);
          }

          if (errors.birthDate) {
            formik.setFieldTouched("birthDate", true);
          }
        }
        break;
      case 2:
        setOpenForm(openForm + 1);
        break;
    }
  };

  const { i18n, t } = useTranslation();
  let numberOfStep;
  let progressClassName1;
  let progressClassName2;
  const handleClickOfGender = (gender: string) => {
    setGender(gender);
    formik.setFieldValue("gender", gender);
    setValidGender(false);
  };
  const removeSymbolsFromInput = (
    evt: React.KeyboardEvent<HTMLInputElement>
  ) => {
    ["e", "E", "+", "-", "."].includes(evt.key) && evt.preventDefault();
  };
  switch (openForm) {
    case 1:
      numberOfStep = 0;
      progressClassName1 =
        "w-[284px] h-[9px] left-0 top-0 absolute bg-zinc-300 rounded-lg";
      progressClassName2 =
        "w-[15px] h-[9px] left-[269px] top-[-0.33px] absolute bg-tart-500 rounded-lg";
      break;
    case 2:
      numberOfStep = 1;
      progressClassName1 =
        "w-[284px] h-[9px] left-0 top-0 absolute bg-zinc-300 rounded-lg";
      progressClassName2 =
        "w-[152px] h-[9px] left-[132px] top-[-0.33px] absolute bg-tart-500 rounded-lg";
      break;
    case 3:
      numberOfStep = 2;
      progressClassName1 =
        "w-[284px] h-[9px] left-0 top-0 absolute bg-zinc-300 rounded-lg";
      progressClassName2 =
        "w-[223px] h-[9px] left-[61px] top-[-0.33px] absolute bg-tart-500 rounded-lg";
      break;
    case 4:
      numberOfStep = 3;
      progressClassName1 =
        "w-[284px] h-[9px] left-0 top-0 absolute bg-zinc-300 rounded-lg";
      progressClassName2 =
        "w-[284px] h-[9px] left-0 top-[-0.33px] absolute bg-tart-500 rounded-lg";
      break;
  }
  const handleClickOnEduSystemOption = (item: string) => {
    setEduSystem(item);
    formik.setFieldValue("eduSystem", item);
    setIsEduSystemSelected(true);
    setShowEduSystemOptions(false);
    setValidEduSystem(false);
  };
  const handleClickOnEduLevelOption = (item: string) => {
    setEduLevel(item);
    formik.setFieldValue("eduLevel", item);
    setIsEduLevelSelected(true);
    setShowEduLevelOptions(false);
    setValidEduLevel(false);
  };
  const handleValidation = () => {
    let hasError = false;
    if (!isEduLevelSelected) {
      setValidEduLevel(true);
      hasError = true;
    }
    if (!isEduSystemSelected) {
      setValidEduSystem(true);
      hasError = true;
    }
    return hasError;
  };
  const handleClickForm3 = () => {
    const hasValidationError = handleValidation();
    if (!hasValidationError) {
      handleNextForms(2);
    }
  };
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      ref={props.addSonFormRef}
      className="fixed top-0 left-0 inset-y-0 inset-x-0 mx-auto my-auto bg-white shadow-[rgba(0,_0,_0,_0.10)_0px_0px_20px_0px] w-[505px] h-[590px] p-8 laptop:w-[505px] mobile:w-[367px] mobile:h-[520px] tablet:w-[480px] tablet:h-[550x] rounded-2xl"
    >
      <Formik
        initialValues={initialValues}
        validationSchema={addSonValidationSchema}
        onSubmit={() => formik.submitForm()}
      >
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
        >
          <div className="flex flex-col items-center gap-6 mobile:gap-3">
            <img
              alt="logo"
              src="/assets/images/logo.svg"
              className="w-56 h-11 mobile:w-[154px] mobile:h-[31px]"
            />
            <div className="flex flex-col w-[425px] mobile:w-[315px] h-[122px]">
              <p className="text-slate-600 text-xl font-arBold">
                {t("form.addSon.addNewSon")}
              </p>
              <div className="w-[284px] h-[58.40px] flex-col justify-center items-start gap-3 flex">
                <div className="text-slate-400 text-base font-arRegular">
                  {numberOfStep} {t("form.addSon.fromFourSteps")}
                </div>
                <div
                  className={`w-[284px] h-[9px] ${
                    i18n.language === "en" && "rotate-180"
                  } relative`}
                >
                  <div className={progressClassName1} />
                  <div className={progressClassName2} />
                </div>
              </div>
            </div>
            {openForm === 1 && (
              <div className="flex flex-col gap-8">
                <div className="flex flex-col justify-start gap-2">
                  <div className="flex flex-col gap-2">
                    <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
                      {t("form.addSon.nameOfSon")}
                    </label>
                    <input
                      id="nameOfSon"
                      name="nameOfSon"
                      type="text"
                      onChange={(e) => formik.handleChange(e)}
                      onBlur={(e) => formik.handleBlur(e)}
                      className={` ${
                        formik.touched.nameOfSon && formik.errors.nameOfSon
                          ? "border-secondary-50 focus:border-secondary-50"
                          : "border-zinc400 focus:border-mint-500"
                      } w-[425px] h-[61px] bg-transparent mobile:w-80 mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
                      placeholder={`${t("form.addSon.nameOfSon")}`}
                    ></input>
                    {formik.errors.nameOfSon && formik.touched.nameOfSon && (
                      <p className="text-secondary-50 text-lg mobile:text-xs font-arMedium">
                        {formik.errors.nameOfSon}
                      </p>
                    )}
                  </div>
                  <div className="flex flex-col gap-2">
                    <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
                      {t("app.shared.birthdate")}
                    </label>
                    <input
                      id="birthDate"
                      name="birthDate"
                      type={type}
                      onFocus={() => setType("date")}
                      onChange={(e) => formik.handleChange(e)}
                      onBlur={(e) => {
                        formik.handleBlur(e);
                        setType("text");
                      }}
                      className={`appearance-none ${
                        formik.touched.birthDate && formik.errors.birthDate
                          ? "border-secondary-50 focus:border-secondary-50"
                          : "border-zinc400 focus:border-mint-500"
                      } w-[425px] h-[61px] bg-transparent mobile:w-80 mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
                      placeholder={`${t("app.shared.birthdate")}`}
                    ></input>
                  </div>
                </div>
                <button
                  onClick={() => handleNextForms(1)}
                  className="w-[425px] mobile:w-[329px] h-11 text-white text-xl font-arRegular bg-mint-500 rounded-2xl"
                >
                  {t("forms.component.next")}
                </button>
              </div>
            )}
            {openForm === 2 && (
              <>
                <div className="w-[425px] mobile:w-[315px] h-[196px] flex-col justify-start items-start gap-2 flex">
                  <div className="w-[425px] mobile:w-[315px] px-4 py-[17px] rounded-[18px] items-start gap-2 flex">
                    <p
                      className={`${
                        validGender ? "text-secondary-50" : "text-zinc600"
                      } text-lg font-arMedium`}
                    >
                      {t("form.addSon.genderOfSon")}
                    </p>
                  </div>
                  <div className="justify-center items-start gap-[19px] inline-flex">
                    <div
                      onClick={() => handleClickOfGender(genderEnum.female)}
                      className={`w-[93px] h-11 px-6 py-3 ${
                        gender === genderEnum.female
                          ? "bg-mint-500"
                          : "bg-white"
                      } rounded-[36px] border border-slate-200 justify-between items-center flex cursor-pointer`}
                    >
                      <p
                        className={`w-[75px] text-center ${
                          gender === genderEnum.female
                            ? "text-white"
                            : "text-slate-600"
                        }  text-base font-arRegular`}
                      >
                        {t("app.shared.female")}
                      </p>
                    </div>
                    <div
                      onClick={() => handleClickOfGender(genderEnum.male)}
                      className={`w-[93px] h-11 px-6 py-3 ${
                        gender === genderEnum.male ? "bg-mint-500" : "bg-white"
                      } rounded-[36px] border border-slate-200 justify-between items-center flex cursor-pointer`}
                    >
                      <p
                        className={`w-[75px] text-center ${
                          gender === genderEnum.male
                            ? "text-white"
                            : "text-slate-600"
                        }  text-base font-arRegular`}
                      >
                        {t("app.shared.male")}
                      </p>
                    </div>
                  </div>
                  {validGender && (
                    <p className="text-secondary-50 px-4 py-4 text-lg font-arMedium">
                      {formik.errors.gender}
                    </p>
                  )}
                </div>

                <button
                  onClick={
                    gender === ""
                      ? () => setValidGender(true)
                      : () => handleNextForms(2)
                  }
                  className="w-[425px] mobile:w-[329px] h-11 text-white text-xl font-arRegular bg-mint-500 rounded-2xl"
                >
                  {t("forms.component.next")}
                </button>
              </>
            )}
            {openForm === 3 && (
              <div>
                <div className="flex flex-col gap-2 mobile:w-80">
                  <SelectProfileForms
                    currrentValue={
                      eduLevel === ""
                        ? i18n.language === "ar"
                          ? list.educationLevel[0]
                          : list.educationLevelEn[0]
                        : eduLevel
                    }
                    showOptions={showEduLevelOptions}
                    isSelected={isEduLevelSelected}
                    onClickOnDropDown={() =>
                      setShowEduLevelOptions(!showEduLevelOptions)
                    }
                    onClickOnOption={(item) =>
                      handleClickOnEduLevelOption(item)
                    }
                    label={t("forms.component.educationevel")}
                    options={
                      i18n.language === "ar"
                        ? list.educationLevel
                        : list.educationLevelEn
                    }
                    validation={
                      <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
                        {formik.errors.eduLevel}
                      </p>
                    }
                    validationErrors={formik.errors.eduLevel}
                    isValid={validEduLevel}
                  />
                  <SelectProfileForms
                    currrentValue={
                      eduSystem === ""
                        ? i18n.language === "ar"
                          ? list.edusystem[0]
                          : list.edusystemEn[0]
                        : eduSystem
                    }
                    showOptions={showEduSystemOptions}
                    isSelected={isEduSystemSelected}
                    onClickOnDropDown={() =>
                      setShowEduSystemOptions(!showEduSystemOptions)
                    }
                    onClickOnOption={(item) =>
                      handleClickOnEduSystemOption(item)
                    }
                    label={t("forms.component.edusystem")}
                    options={
                      i18n.language === "ar"
                        ? list.edusystem
                        : list.educationLevelEn
                    }
                    validation={
                      <p className="text-base mobile:text-xs font-arMedium text-secondary-50">
                        {formik.errors.eduSystem}
                      </p>
                    }
                    validationErrors={formik.errors.eduSystem}
                    isValid={validEduSystem}
                  />
                </div>
                <button
                  onClick={handleClickForm3}
                  className={`${
                    validEduSystem ? "mt-0" : "mt-8"
                  }  w-[425px] mobile:w-[329px] h-11 text-white text-xl font-arRegular bg-mint-500 rounded-2xl`}
                >
                  {t("forms.component.next")}
                </button>
              </div>
            )}
            {openForm === 4 && (
              <div>
                <div className="flex flex-col gap-2 h-[196px]">
                  <label className="text-zinc700 text-xl leading-[30px] font-arMedium">
                    {t("app.shared.idNumber")}
                  </label>
                  <input
                    id="idNumber"
                    name="idNumber"
                    type="number"
                    onKeyDown={removeSymbolsFromInput}
                    onChange={(e) => formik.handleChange(e)}
                    onBlur={(e) => formik.handleBlur(e)}
                    className={`${
                      formik.errors.idNumber && formik.touched.idNumber
                        ? "border-secondary-50 focus:border-secondary-50"
                        : "border-zinc400 focus:border-mint-500"
                    }  w-[425px] h-[61px] bg-transparent mobile:w-80 mobile:h-[61px] mobile px-4 py-[17px] rounded-[18px] border placeholder:text-zinc300 placeholder:text-lg placeholder:font-arMedium focus:outline-none caret-mint-500`}
                    placeholder={`${t("app.shared.idNumber")}`}
                  ></input>
                  {formik.errors.idNumber && formik.touched.idNumber && (
                    <p className="text-secondary-50 text-lg mobile:text-xs font-arMedium">
                      {formik.errors.idNumber}
                    </p>
                  )}
                </div>
                <button
                  type="submit"
                  className="w-[425px] mobile:w-[329px] h-11 text-white text-xl font-arRegular bg-mint-500 rounded-2xl"
                >
                  {t("app.shared.save")}
                </button>
              </div>
            )}
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default AddSonFormComponent;
